import type { SxProps, Theme } from '@mui/material';
import { Color } from 'shared/utils/colors';

export const dashboardContainerSx: SxProps<Theme> = {
  padding: '24px 24px 120px 24px',
  backgroundColor: Color.solidGray,
};
